<template>
    <div class="item" @click="onPressNav('fortune', {id: item.id, type: 'list'})">
        <div class="td-f1">
            <p class="title">{{item.name}}</p>
            <!-- <p class="time">{{item.time}}</p> -->
            <p class="text">{{item.overview}}</p>
        </div>
        <div class="img" v-if="item.image">
            <img :src="item.image" />
        </div>
    </div>
</template>
<script>
export default {
    name: "articleItem",
    props:['item'],
    data() {
        return {
            
        };
    },
    methods: {
        onPressNav(router, query={}) {
            this.$router.push({path: '/'+router, query: query})
        },
    },
    created() {
        console.log('this', this)
    },
};
</script>
<style lang="less" scoped>
.item {
    margin: 10px 15px;
    padding: 10px;
    background: #fff;
    display: flex;

    > div {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .title {
            font-size: 15px;
            color: #333;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
        
        .time {
            font-size: 13px;
            color: #999;
        }

        .text {
            font-size: 12px;
            color: #999;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
        }
    }

    .img {
        width: 100px;
        height: 100px;
        margin-left: 10px;
        flex-shrink: 0;
        img{
            width: 100%;
            height: 100%;
            object-fit: cover;
            display: block;
        }
    }
}
</style>